import React, { FC, useState } from 'react';
import { Box, Tab, Tabs, Typography } from '@mui/material';
import DnvForm from './DnvForm';
import DnvStatsPanel from './DnvStatsPanel';
import DnvSendsHistory from './DnvSendsHistory';
import DnvBlacklist from './DnvBlacklist';

const DnvAssetAnalysis: FC = () => {
  const [activeTab, setActiveTab] = useState(0);

  return (
    <Box m="20px">
      <Typography variant="h4" fontWeight="bold" mb={1}>
        DNV Asset-Analyse Mailing
      </Typography>
      <Typography variant="body2" color="textSecondary" mb={3}>
        Self-Service-Export einer Einzel-Analyse-SAM (Produkt 100013, Customer MSM) für
        DNVs eigenen ESP. Affiliate <code>DNV_Asset_Analysis_SAM</code>.
      </Typography>

      <Tabs
        value={activeTab}
        onChange={(_e, val) => setActiveTab(val)}
        sx={{ mb: 3, borderBottom: 1, borderColor: 'divider' }}
      >
        <Tab label="Mailing erstellen" />
        <Tab label="Bisherige Kampagnen" />
        <Tab label="Verlauf" />
        <Tab label="Blacklist" />
      </Tabs>

      {activeTab === 0 && <DnvForm />}
      {activeTab === 1 && <DnvStatsPanel />}
      {activeTab === 2 && <DnvSendsHistory />}
      {activeTab === 3 && <DnvBlacklist />}
    </Box>
  );
};

export default DnvAssetAnalysis;
